var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8861 6.42607C23.8807 5.77258 22.9903 3.15709 20.7047 3.00671C20.5689 2.99776 20.4323 2.99776 20.2964 3.00671C18.0109 3.15711 17.1205 5.77243 15.1151 6.42607C12.9916 7.11786 10.0881 5.69982 8.29014 7.27858C6.55952 8.79813 8.09097 11.4449 7.31923 13.2712C6.53029 15.1373 3.23112 15.9092 3.42495 18.1793C3.59623 20.1861 6.57498 20.9679 7.31923 22.7288C8.091 24.555 6.55943 27.2019 8.29014 28.7214C10.0879 30.3002 12.9916 28.8827 15.1151 29.5739C17.12 30.2283 18.0112 32.8431 20.2964 32.9933C20.4323 33.0023 20.5689 33.0023 20.7047 32.9933C22.99 32.8431 23.8814 30.2282 25.8861 29.5739C27.9662 28.8968 30.9809 30.2411 32.7111 28.7214C34.5685 27.0908 32.7789 24.4471 33.7602 22.563C34.6671 20.8282 37.765 20.0158 37.5762 17.8207C37.4052 15.8142 34.4273 15.0315 33.6819 13.2712C32.8947 11.4067 34.5091 8.85709 32.7111 7.27858C30.9132 5.69974 28.0096 7.1179 25.8861 6.42607Z",
    stroke: "#5C11A7",
    strokeWidth: 2.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9137 24V18C20.9137 17.2929 20.9137 16.9394 20.6634 16.7196C20.4133 16.5 20.0106 16.5 19.2053 16.5",
    stroke: "#5C11A7",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4866 12H20.5016",
    stroke: "#5C11A7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsIcon);
export default __webpack_public_path__ + "static/media/alerts-icon.f7c4bb80e4afbed28a4c37132a58092b.svg";
export { ForwardRef as ReactComponent };